<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
          [{"num_cand":"U2FsdGVkX19MbMZ4ge/HKhIIRm/jniJQZL0YPz8m1Fo=","cpf":"U2FsdGVkX1/uw7YGpAdJ21Vb0GLwFYCb3k3FU8R24gA="},{"num_cand":"U2FsdGVkX18Ny3jcp1sALk0t6poz3lHuOF9XNpTowNw=","cpf":"U2FsdGVkX1+7iLBaRZEX2pespqsL7R10Z+BP47JRUpc="},{"num_cand":"U2FsdGVkX1/HMp4oU342Nefc5DHW6qEQZJAl3ksZDTw=","cpf":"U2FsdGVkX19DIVpnqQO1IfRji5LJXh8fIruAvozaH3Q="},{"num_cand":"U2FsdGVkX1/tz2P18UakQg9GiwFm6vwY4Ai+BfPgTd0=","cpf":"U2FsdGVkX1/FXu+gkmzFwcfmMlllAn9s9JOzRzD0z7g="},{"num_cand":"U2FsdGVkX1+plWSdPxT9fYuFOG1XMqOOGiUMRJSnj9o=","cpf":"U2FsdGVkX18EorDXX79okE8daP5dymake2eYJRm60II="},{"num_cand":"U2FsdGVkX1/JvXfdk7SFpnE5A5RSIywIvEEKsv1/B0c=","cpf":"U2FsdGVkX19ViE+jMye9QHnc0vxRejAuolByeC3zM5w="},{"num_cand":"U2FsdGVkX191LTl0yRzELchi9F/BkdRvrwdxo6f7wk8=","cpf":"U2FsdGVkX1/C84e1+h4ToopwstqGVejYRwnxEpWN+iw="},{"num_cand":"U2FsdGVkX1+jqb5uQeWT81RQVzryFrLKoGxaJd9Dy4I=","cpf":"U2FsdGVkX19QprGYAd36Bcz08SVqluGHhYbO5M23khU="},{"num_cand":"U2FsdGVkX182Fhc302w62skg1WcdBhefxqkCLKAmJLg=","cpf":"U2FsdGVkX1/I5QXGOECGgXCmuK1bnH6VSp/a625rYAM="},{"num_cand":"U2FsdGVkX19i9tlsRBBdHTWyKgSbo3hYaw5AzylDexY=","cpf":"U2FsdGVkX1+3Qv8FzcpQxdHyTM3xIfL9V9BxdeZ3chI="},{"num_cand":"U2FsdGVkX1+YpsvJ8XWhvTVw6CCQRlmYtWujYZtcUs8=","cpf":"U2FsdGVkX1/CD9iDff10zanq917PBTrNFaueBBCakdA="},{"num_cand":"U2FsdGVkX19dmaqswOI35MZNd2T1Gzsi1r1QuGg7jpQ=","cpf":"U2FsdGVkX18USdmjh8CjygZzkUT4LCnfFRF5J/zS+Os="},{"num_cand":"U2FsdGVkX18ptGPZeZ6AannOw5/qZUu4aH+qp30rypQ=","cpf":"U2FsdGVkX1++hyEB3ovqotm+s+Vpw/h9/ZFs75Z1Vdc="},{"num_cand":"U2FsdGVkX19405PPC64eQAl8mKCS7/WA0qc+8NeyXcU=","cpf":"U2FsdGVkX19Ou8wePF+ieWAgw8dUUCZtj8fuqArsPxM="},{"num_cand":"U2FsdGVkX1/ovC3lXKRq+iP9sgX9AYhyZzg5pG3Q+fQ=","cpf":"U2FsdGVkX18u6Ve4X+whulJyiAQ/7bAzXZMbRXs40WY="},{"num_cand":"U2FsdGVkX19+T0x5+rV36M7lzYFfdHc7TuS1xNrbMcw=","cpf":"U2FsdGVkX18nW9G97N3TckRRADxBgTGBj6z44w3RONo="},{"num_cand":"U2FsdGVkX1+Mh310MXuJM69FJJuOH8zwJfZaBBdQyAs=","cpf":"U2FsdGVkX18YmbBth4A5xqAEP8Rgs9DuuujfUS2XSS4="},{"num_cand":"U2FsdGVkX1/qV4xAEuCAmDcb+9pmAdOP6uIFuGtfnug=","cpf":"U2FsdGVkX19RtTHBpBs7SEkO2ULzJvAPoNadCerLRCo="},{"num_cand":"U2FsdGVkX18lrLIn3lSuNHvOCdhyJBmxgonQ5Kyy8dw=","cpf":"U2FsdGVkX1/SIMmuYdfd4u5dL2XC+bnkIG27/BAkOgU="},{"num_cand":"U2FsdGVkX19L8ME8ylmRmXA3sz8Ngo6WF/tInlZZ/H4=","cpf":"U2FsdGVkX1/Mc3SKgqN8l87eLQ/F7NnuypQblL3DT+s="},{"num_cand":"U2FsdGVkX1+AHaZpBn9dtTsMqWm9fa//gz+/1bI4Cyk=","cpf":"U2FsdGVkX1/5MIJx1ZVvCLQkjtSF8PzOEgWlmFG/yBk="},{"num_cand":"U2FsdGVkX18ZWy7hGzZoZ/oC/FWJpk0s04BH3sZq9n4=","cpf":"U2FsdGVkX1+vL4M4yvyALae5HBu0jGgYr4Z183n4UtE="},{"num_cand":"U2FsdGVkX19p8uSYetjTMr0mo+LjIqj9azTSkHvDb1o=","cpf":"U2FsdGVkX1+ZK4Sezb/cRokBrK6RLDQSB71z0r2Pa0Y="},{"num_cand":"U2FsdGVkX19TG5pQ2cR8AGJALlZoEVj6t0ovsuRFZfo=","cpf":"U2FsdGVkX1+BlUyJhCZDY7gWnbcfcwottCAenj8oa9k="},{"num_cand":"U2FsdGVkX1/rZ0Wjeg7012OjB4d/PQXZIFsPL7nCR1s=","cpf":"U2FsdGVkX1/se7yTqZBorKi27W1Ro2b02mkPCBi+71Y="},{"num_cand":"U2FsdGVkX18Dq5jYizi8pcQA66tzfrz03GUGT3c/8OY=","cpf":"U2FsdGVkX1+6RdJwHQeLsR5dixPUc6wYRF0OMtdSlN0="},{"num_cand":"U2FsdGVkX18rIYhZLP1FajYk9N/1SuCKKzM0iCXyAT4=","cpf":"U2FsdGVkX1/yJMVdmW/8IKnXuST+bAfH9KP9PbiQBOg="},{"num_cand":"U2FsdGVkX1+vRJfmwEpUyIeMY+th+6933Fp8U1npM1w=","cpf":"U2FsdGVkX19QEeHG32MpmKPX5dU4KAvtsnzTKHLMig4="},{"num_cand":"U2FsdGVkX1+2vbB7VYPajDwy/vXmzuGPYd4B7QZuxUY=","cpf":"U2FsdGVkX19XcgBK/iTz/jdwGS5RjL+606seFa8ACfk="},{"num_cand":"U2FsdGVkX1/fmCZ5HO0DbvpjF+L41p/eIo4adrplunE=","cpf":"U2FsdGVkX19vn6ZmzHHhbWe/gSIaER2hNRup0ynZZQ8="},{"num_cand":"U2FsdGVkX1/BQkpK4y2YQK6g8txOJhD5uI/lKgXzGN4=","cpf":"U2FsdGVkX1+Vyf1nmrVxTHTuDNoe4IDCeg/MCGSvpHQ="},{"num_cand":"U2FsdGVkX1+OcfVCS4S6HVmdwv83oo0FGovVNmXvpoA=","cpf":"U2FsdGVkX18FjuT14GwgOWeOd6Lj5xnyp+xDLkEkbWM="},{"num_cand":"U2FsdGVkX18gm3hyJ2yNmiDoYQVM+ULoo2rTkCsivmI=","cpf":"U2FsdGVkX1/gz60or0xOmiJdVLZLIYoSGw7T5+EdwSA="},{"num_cand":"U2FsdGVkX1/s36EBO14187fFa2fWZ7dWJcD8mT5Xk4Q=","cpf":"U2FsdGVkX1/Ymjthx3IagmRJtqdNqSMdarFfA1fPcyg="},{"num_cand":"U2FsdGVkX19D0Gi2WBRp6EmS1kk+t84kpE6mb7HoY+U=","cpf":"U2FsdGVkX1+v1/l3/Xp9ehCh5Rz3wADYtmbmSBOyUgA="},{"num_cand":"U2FsdGVkX19xq7B2B364nSLDSDd/MAKciSGvabg4Avg=","cpf":"U2FsdGVkX183WNecpN35tJi9RPyIKiTkTHA4ctw7FVc="},{"num_cand":"U2FsdGVkX185ZFinMSI5ofE926AqrHib7worU8rMS8U=","cpf":"U2FsdGVkX1+Hj4E8TRrDMMbIehJ5qGESk3RV+STl13s="},{"num_cand":"U2FsdGVkX18Z69WjxgYRfxzS5clenbjDfuYmXgD8fkw=","cpf":"U2FsdGVkX19eZ9Cg+0yVNGr+rKSi6lX2ka4CsJT0sxw="},{"num_cand":"U2FsdGVkX18jiKBapLxd1wW/Mq3ll/Jrs+v8tCAs/xE=","cpf":"U2FsdGVkX1/5PV6bB79WngOn7kXbB6u/SNV1+yqQLAA="},{"num_cand":"U2FsdGVkX19bGZn+AtFDiFiS1lfjparSHRU53NI1Yms=","cpf":"U2FsdGVkX19vwQnJ+y9UwRNyCp9iOXCN/kM+0snvXj4="},{"num_cand":"U2FsdGVkX1/KLUeUvYdKr9L5uUAL/HcyfpU7DLFi/Ys=","cpf":"U2FsdGVkX18fmnsVDJMFYfx0NepgbQDWx8pwUTRnC78="}]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2221/rec_isenc/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
